export default "__VITE_ASSET__d04efeb1__"